module.exports = __webpack_public_path__ + "static/l7-hero-image-2cdbeb7c6422c76d47676a9e2cf32674.png";